import { useState, useEffect } from "react";
import { CDBSidebarMenu } from "cdbreact";
import { NavLink } from "react-router-dom";
import { FaFileWaveform } from "react-icons/fa6";
import {
  Avatar,
  CardHeader,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LineAxisIcon from "@mui/icons-material/LineAxis";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import CameraOutdoorIcon from "@mui/icons-material/CameraOutdoor";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu1 from "@mui/material/Menu";
import { RUTA_IMG, version } from "../componentes/config";
import NoFoto from "../assets/noFoto.jpg";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { sql } from "../componentes/api";

const ITEM_HEIGHT = 48;

const Menu = (props) => {
  const [fileDataURL, setFileDataURL] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    {
      props.Foto !== ""
        ? setFileDataURL(RUTA_IMG + "fotos/" + props.Foto)
        : setFileDataURL(NoFoto);
    }
  }, [props.Foto]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event, idMenu) => {
    event.preventDefault();
    setAnchorEl(null);
  };

  const cerrarSesion = (event) => {
    event.preventDefault();
    const resp = sql("updateConexion", "PUT", {
      NumIngresos: null,
      Id: props.Id,
      Socket: props.Socket.id,
    });
    props.cerrarSesion();
  };

  return (
    <div className="container">
      <div className="row">
        <CardHeader
          avatar={<Avatar src={fileDataURL} />}
          action={
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
          }
          title={props.Nbres}
        />
      </div>

      <div className="row">
        <div className="form-text text-center">{props.Proyecto}</div>
        <div className="form-text text-center">
          <p>
            Ecosistema Versión:{" "}
            <span className="badge text-bg-secondary">{version}</span>
          </p>
        </div>
        <button
          className="btn btn-primary"
          onClick={(event) => cerrarSesion(event)}
        >
          <span> Salir (Log Out)</span>
        </button>
      </div>
      <hr />

      <div className="row">
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <Menu1
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "20ch",
              },
            }}
          >
            <CDBSidebarMenu>
              <NavLink exact="true" to="/foto">
                <ListItemButton>
                  <ListItemText primary="Cambiar Foto" />
                </ListItemButton>
              </NavLink>
            </CDBSidebarMenu>
          </Menu1>

          <CDBSidebarMenu>
            <NavLink exact="true" to="/dash">
              <ListItemButton>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/proyecto">
              <ListItemButton>
                <ListItemIcon>
                  {" "}
                  <LineAxisIcon />{" "}
                </ListItemIcon>
                <ListItemText primary="Proyecto" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/actividad">
              <ListItemButton>
                <ListItemIcon>
                  {" "}
                  <AccountTreeIcon />{" "}
                </ListItemIcon>
                <ListItemText primary="Actividades" />
              </ListItemButton>
            </NavLink>
            <hr />

            <NavLink exact="true" to="/beneficiarios">
              <ListItemButton>
                <ListItemIcon>
                  {" "}
                  <SupervisorAccountIcon />{" "}
                </ListItemIcon>
                <ListItemText primary="Beneficiarios" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/caracterizacion">
              <ListItemButton>
                <ListItemIcon>
                  {" "}
                  <FaFileWaveform />{" "}
                </ListItemIcon>
                <ListItemText primary="Caracterizacion" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/seguimiento">
              <ListItemButton>
                <ListItemIcon>
                  <TroubleshootIcon />
                </ListItemIcon>
                <ListItemText primary="Seguimiento a Beneficiarios" />
              </ListItemButton>
            </NavLink>

            <hr />
            <NavLink exact="true" to="/chat">
              <ListItemButton>
                <ListItemIcon>
                  <WhatsAppIcon />
                </ListItemIcon>
                <ListItemText primary="Chat" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/foro">
              <ListItemButton>
                <ListItemIcon>
                  <RecordVoiceOverIcon />
                </ListItemIcon>
                <ListItemText primary="Foro" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/sala">
              <ListItemButton>
                <ListItemIcon>
                  <CameraOutdoorIcon />
                </ListItemIcon>
                <ListItemText primary="Salas de Reunión" />
              </ListItemButton>
            </NavLink>
          </CDBSidebarMenu>
        </List>
      </div>
    </div>
  );
};

export default Menu;
